document.addEventListener("DOMContentLoaded", () => {
	const sections = document.querySelectorAll(".section__product-slider");

	sections.forEach((section) => {
		const autoSwitchEnabled =
			(section.dataset.autoSwitchEnabled ??
				section.getAttribute("data-auto-switch-enabled")) !== "false";
		if (!autoSwitchEnabled) return;

		// support both dataset and attribute access
		const raw =
			section.dataset.autoSwitchInterval ??
			section.getAttribute("data-auto-switch-interval");
		const intervalSeconds = Number.isFinite(Number(raw))
			? Math.max(0, parseInt(raw, 10))
			: 0;
		if (!intervalSeconds) return;

		const buttons = Array.from(
			section.querySelectorAll(".section__product-slider--tab-button"),
		);
		if (buttons.length < 2) return; // nothing to rotate

		let current = buttons.findIndex((b) => b.classList.contains("is-active"));
		if (current === -1) current = 0;
		let timer = null;
		let lastStart = 0; // timestamp when timer started
		let remaining = intervalSeconds * 1000; // ms remaining until next switch
		let paused = false;
		let justStoppedAt = 0;
		let isAutoSwitching = false;

		const clearTimers = () => {
			if (timer) {
				clearTimeout(timer);
				timer = null;
			}
		};

		const queueNext = (delay = remaining) => {
			clearTimers();
			lastStart = performance.now();
			timer = setTimeout(next, delay);
		};

		const goTo = (idx) => {
			idx = ((idx % buttons.length) + buttons.length) % buttons.length;
			current = idx;
			// simulate user click
			isAutoSwitching = true;
			try {
				buttons[idx].click();
			} catch {
				/* fallback: dispatch event */
				const ev = new MouseEvent("click", { bubbles: true, cancelable: true });
				buttons[idx].dispatchEvent(ev);
			} finally {
				isAutoSwitching = false;
			}
		};

		const next = () => {
			// don't advance while paused, hovered, focused, or immediately after a stop (race protection)
			if (paused) return;
			if (section.matches(":hover") || section.matches(":focus-within")) return;
			if (justStoppedAt && performance.now() - justStoppedAt < 250) return;
			goTo(current + 1);
			// reset remaining and schedule next
			remaining = intervalSeconds * 1000;
			queueNext(remaining);
		};

		const start = () => {
			// resume timer using remaining time
			paused = false;
			justStoppedAt = 0;
			// if remaining is 0 or negative, run immediately
			if (remaining <= 0) {
				if (!paused) next();
				return;
			}
			queueNext(remaining);
		};

		const stop = () => {
			// always update remaining based on elapsed since last start
			const elapsed = performance.now() - lastStart;
			remaining = Math.max(0, remaining - elapsed);
			justStoppedAt = performance.now();
			clearTimers();
			paused = true;
		};

		// pause on user interaction — use pointerenter/pointerleave to ignore child moves
		section.addEventListener("pointerenter", stop);
		section.addEventListener("pointerleave", start);
		// also listen for pointerover/pointerout and check relatedTarget to ensure entering from outside
		const isInside = (node) => node && section.contains(node);
		section.addEventListener("pointerover", (e) => {
			if (!isInside(e.relatedTarget)) stop();
		});
		section.addEventListener("pointerout", (e) => {
			if (!isInside(e.relatedTarget)) start();
		});
		section.addEventListener("focusin", stop);
		section.addEventListener("focusout", start);
		section.addEventListener("pointerdown", stop, { passive: true });
		section.addEventListener("touchstart", stop, { passive: true });

		// On touch devices, pause when the section enters the viewport
		const isTouchDevice =
			"ontouchstart" in window ||
			(navigator.maxTouchPoints || 0) > 0 ||
			window.matchMedia?.("(pointer:coarse)").matches;
		let io = null;
		if (isTouchDevice && "IntersectionObserver" in window) {
			io = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.target !== section) return;
						if (entry.isIntersecting) {
							stop();
						} else {
							start();
						}
					});
				},
				{ threshold: 0.1 },
			);

			io.observe(section);
			// expose observer for debugging/cleanup
			section._autoSwitchObserver = io;
		}

		// reset timer when user manually clicks a button
		buttons.forEach((btn, idx) => {
			btn.addEventListener("click", () => {
				current = idx;
				if (isAutoSwitching) {
					remaining = intervalSeconds * 1000;
					return;
				}
				clearTimers();
				paused = false;
				justStoppedAt = 0;
				// keep the clicked tab active for one full interval, then switch normally
				remaining = intervalSeconds * 1000;
				queueNext(remaining);
			});
		});

		// start rotating
		start();
		// expose for debugging
		section._autoSwitch = { start, stop, goTo };
	});
});
